import { Directive, TemplateRef, ViewContainerRef, computed, effect, inject, input } from "@angular/core";
import { AccessControlService, AclType } from "@dis/auth";

@Directive({
  selector: "[hasRole]",
})
export class HasRoleDirective {
  readonly hasRole = input<AclType>("canRead");
  readonly hasRoleElse = input<TemplateRef<unknown> | null>(null);

  readonly #templateRef = inject(TemplateRef<unknown>);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #accessControl = inject(AccessControlService);

  readonly #shouldShow = computed(() => this.#accessControl.hasAccess(this.hasRole()));

  #currentView: "primary" | "else" | null = null;

  constructor() {
    effect(() => {
      const shouldShow = this.#shouldShow();
      const elseTemplate = this.hasRoleElse();

      if (shouldShow) {
        if (this.#currentView !== "primary") {
          this.#viewContainer.clear();
          this.#viewContainer.createEmbeddedView(this.#templateRef);
          this.#currentView = "primary";
        }
        return;
      }

      if (elseTemplate) {
        if (this.#currentView !== "else") {
          this.#viewContainer.clear();
          this.#viewContainer.createEmbeddedView(elseTemplate);
          this.#currentView = "else";
        }
        return;
      }

      if (this.#currentView !== null) {
        this.#viewContainer.clear();
        this.#currentView = null;
      }
    });
  }
}
